var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFixelLogo2019Vector1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 33,
    viewBox: "0 0 104 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.631695 5.82451H6.44046V0.000976562H0.631695V5.82451Z",
    fill: "#F2BE41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41035 5.82353H13.2264V0H7.41035V5.82353Z",
    fill: "#F2BE41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1959 5.82353H20.0119V0H14.1959V5.82353Z",
    fill: "#F2BE41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.632244 12.6176H6.44101V6.79407H0.632244V12.6176Z",
    fill: "#F2BE41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.632244 19.4118H6.44101V13.5883H0.632244V19.4118Z",
    fill: "#F2BE41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41035 19.4118H13.2264V13.5883H7.41035V19.4118Z",
    fill: "#F2BE41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1959 19.4118H20.0119V13.5883H14.1959V19.4118Z",
    fill: "#F2BE41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.632244 26.2059H6.44101V20.3823H0.632244V26.2059Z",
    fill: "#F2BE41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.632244 32.9999H6.44101V27.1764H0.632244V32.9999Z",
    fill: "#F2BE41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9198 33H28.7358V0H22.9198V33Z",
    fill: "#575E68"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 0,
    width: 21,
    height: 33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.0802 0V5.82353H67.5095V13.5882H81.0802V19.4118H67.5095V27.1765H81.0802V33H61.6934V0H81.0802Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6867 33.0004H81.0832V-0.00445557H61.6867V33.0004Z",
    fill: "#575E68"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 0,
    width: 21,
    height: 33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.8043 0V27.1765H103.375V33H83.9882V0H89.8043Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9768 33.0003H103.388V-0.0045166H83.9768V33.0003Z",
    fill: "#575E68"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: -1,
    width: 29,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3176 0.0139007C39.5308 0.0157205 39.8376 0.115934 39.9414 0.287849C41.7829 3.34399 43.5999 6.41833 45.4636 9.55891C45.8688 8.89369 46.2677 8.2406 46.6648 7.58691C48.1242 5.18689 49.5776 2.78262 51.0523 0.394493C51.1683 0.206805 51.4311 0.021544 51.6273 0.0191176C53.9615 -0.00672434 56.2961 0.00201095 58.6306 0.00358816C58.6825 0.00358816 58.7338 0.0248198 58.8806 0.0573345C58.746 0.292095 58.6347 0.497132 58.5144 0.695253C55.539 5.5943 52.5678 10.4963 49.577 15.384C49.3202 15.8038 49.3443 16.07 49.6215 16.4506C53.2251 21.3941 56.3252 26.7073 59.0692 32.279C59.1613 32.4661 59.2486 32.6564 59.3912 32.957C59.1401 32.9717 58.9885 32.9883 58.8368 32.9883C56.5374 32.9895 54.2384 32.9768 51.9393 32.9999C51.5269 33.0038 51.3097 32.8608 51.1202 32.4564C49.9165 29.8899 48.7533 27.2925 47.1518 24.9882C46.5747 24.1581 45.8993 23.4115 45.2173 22.5627C44.8988 22.9758 44.6423 23.2921 44.4019 23.6228C42.3616 26.4329 40.502 29.3746 39.0248 32.5992C38.9396 32.7854 38.6592 32.9701 38.468 32.9723C36.1688 32.9992 33.8698 32.9917 31.5704 32.9917C31.5028 32.9917 31.4353 32.9729 31.2803 32.9497C31.3732 32.7253 31.4391 32.5382 31.5253 32.3632C34.1274 27.076 37.3799 22.2724 40.5924 17.438C41.5533 15.9922 41.5574 16.5902 40.6666 15.0888C37.8065 10.269 34.9222 5.46691 32.0481 0.657886C31.9431 0.482331 31.8449 0.302165 31.7077 0.0615808C31.8945 0.0361029 32.0247 0.00298154 32.1547 0.00261757C34.5422 -7.24497e-05 36.93 -0.0055111 39.3176 0.0139007Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.269 33.0002H59.4041V-0.00469971H31.269V33.0002Z",
    fill: "#575E68"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102.75,
    height: 33,
    fill: "white",
    transform: "translate(0.625)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixelLogo2019Vector1);
export default __webpack_public_path__ + "static/media/Fixel_Logo2019vector1.4b7dbb92.svg";
export { ForwardRef as ReactComponent };